{"boat":"Add a boat","trip":"Add trip","task":"Add task","inventory":"Add inventory item","cost":"Add cost"}